import { render, staticRenderFns } from "./OrderItemDetails.vue?vue&type=template&id=ecb40c9c"
import script from "./OrderItemDetails.vue?vue&type=script&lang=js"
export * from "./OrderItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports